import { Component, Input } from '@angular/core';
import { IRecommendationAdjustedTask } from '../../../../../interfaces/route-recommendations/recommendation-task';
import { CommonModule } from '@angular/common';
import { VmePipesModule } from '../../../../../vme-pipes.module';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { RouteItinerarySiteHoursComponent } from '../route-itinerary-site-hours/route-itinerary-site-hours.component';

@Component({
  selector: 'route-itinerary-task-expander',
  templateUrl: './route-itinerary-task-expander.component.html',
  styleUrls: ['./route-itinerary-task-expander.component.scss'],
  animations: [
    trigger('slideInOut', [
      state('closed', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
      state('open', style({ height: '*', opacity: 1 })),
      transition('closed <=> open', [animate('300ms ease-in-out')]),
    ]),
  ],
  standalone: true,
  imports: [CommonModule, VmePipesModule, RouteItinerarySiteHoursComponent],
})
export class RouteItineraryTaskExpanderComponent {
  @Input() task: IRecommendationAdjustedTask;
  @Input() expanded: boolean = false;
  @Input() taskNumber: number;
}
